import { memo } from "react"
import { StyleSheet, View } from "react-native"
import { Circle, G, Path, Svg, Text, TSpan } from "react-native-svg"
import { Colors } from "src/constants/Colors"
import { Button } from "src/components/parts/buttons/Button"

type Props = {
  onPress: () => void
}

export const ContactListFooter = memo<Props>(({ onPress }) => {
  return (
    <View style={styles.container}>
      <Button onPress={onPress} style={styles.button}>
        <View>
          <Svg width={122} height={137} viewBox="0 0 122 137" fill="none">
            <Path
              d="M68 106.075c20.987 0 38-16.933 38-37.82 0-20.888-17.013-37.821-38-37.821s-38 16.933-38 37.82c0 20.888 17.013 37.821 38 37.821z"
              fill="#F0830E"
            />
            <Path
              d="M68 104.582c20.158 0 36.5-16.264 36.5-36.327 0-20.064-16.342-36.328-36.5-36.328S31.5 48.19 31.5 68.255c0 20.063 16.342 36.327 36.5 36.327z"
              stroke="#fff"
              strokeWidth={3}
            />
            <Path
              d="M61.672 75.817v7.896c0 .854-.014 1.274-.084 1.68h1.694c-.07-.392-.098-.84-.098-1.68v-1.61h2.296c.532 0 .938.028 1.4.084V80.66c-.42.07-.798.084-1.4.084h-2.296v-1.792h2.268c.532 0 .952.028 1.4.084v-1.512c-.42.056-.798.084-1.386.084h-2.282v-1.792h2.66c.616 0 1.106.028 1.512.07v-1.512c-.392.056-.826.084-1.512.084h-3.808c.126-.308.14-.35.35-.938.098-.28.14-.406.28-.742l-1.582-.462c-.07.49-.28 1.19-.63 2.03-.602 1.414-1.288 2.478-2.352 3.57.476.49.672.742 1.008 1.316a15.225 15.225 0 002.296-3.416h.266zm-4.102-3.542c-.084.546-.28 1.12-.588 1.848-.714 1.61-1.624 2.926-2.66 3.864.35.588.546.994.742 1.638.504-.518.854-.952 1.344-1.61-.042 1.176-.042 1.246-.042 1.596v3.99c0 .728-.028 1.204-.098 1.736h1.68a12.927 12.927 0 01-.098-1.736v-7.756c.728-1.638.728-1.638.952-2.24.126-.336.168-.434.322-.784l-1.554-.546zm21.518 4.48c-.168.98-.644 2.142-1.344 3.276-.322-1.064-.518-2.352-.644-4.186h2.52c.714 0 1.246.028 1.708.07v-1.54c-.364.07-.742.084-1.484.084h-.42l.728-.504c-.532-.686-.77-.924-1.414-1.47l-1.078.686c.574.476.84.77 1.232 1.288h-1.848v-.644c0-.462.028-1.036.07-1.33h-1.666c.056.308.056.364.07.882.028.616.028.98.042 1.092H71.5c-.728 0-1.302-.028-1.806-.07.07.56.084.91.084 1.988 0 2.492-.14 4.354-.42 5.53-.182.798-.476 1.456-.966 2.212.504.364.784.63 1.218 1.19.616-.98.896-1.61 1.148-2.73.21-.952.336-1.918.434-3.514h2.044c-.028 1.134-.098 2.044-.21 2.534-.07.35-.196.434-.63.434-.406 0-.616-.014-1.358-.112.21.546.294.882.364 1.484.448.028.672.042 1.064.042 1.078 0 1.582-.21 1.806-.77.238-.588.322-1.33.462-3.85.028-.546.056-.938.084-1.19-.294.042-.504.056-.994.056h-2.576c.014-.504.014-.504.028-1.848h4.34c.154 2.464.462 4.144 1.05 5.586a10.508 10.508 0 01-3.766 2.576c.476.406.63.574 1.064 1.218 1.246-.616 2.338-1.414 3.388-2.45.812 1.316 1.918 2.254 2.632 2.254.77 0 1.26-.826 1.582-2.716-.602-.322-.784-.462-1.26-.938-.168 1.316-.168 1.316-.266 1.638-.07.182-.126.266-.182.266-.084 0-.392-.252-.63-.504a6.032 6.032 0 01-.84-1.204c.714-.966 1.274-1.988 1.89-3.5.224-.532.224-.532.308-.742l-1.498-.574z"
              fill="#fff"
            />
            <Path
              d="M79.412 59.626a.662.662 0 00-.66.657v3.125h-3.138a.662.662 0 00-.66.657.656.656 0 00.66.658h3.14v3.122a.656.656 0 00.66.657.663.663 0 00.66-.657v-3.124h3.138a.662.662 0 00.66-.658.656.656 0 00-.66-.657h-3.14v-3.123a.654.654 0 00-.407-.607.66.66 0 00-.253-.05z"
              fill="#fff"
              stroke="#fff"
            />
            <Path
              d="M72 65.27H58.48a3.007 3.007 0 01-2.12-.874 2.98 2.98 0 01-.88-2.111v-9.977c0-.157.013-.313.038-.468a.99.99 0 01.408-1.095 2.977 2.977 0 012.554-1.423h19.04c.795 0 1.558.315 2.12.875.563.56.88 1.32.88 2.111v4.989h-2v-4.222l-10.206 5.642a1.005 1.005 0 01-.972 0l-9.861-5.452v9.02c0 .264.105.517.292.704.188.186.442.291.707.291H72v1.99zM58.48 51.314a.985.985 0 00-.317.052l9.665 5.343 9.752-5.395H58.481z"
              fill="#fff"
            />
          </Svg>
        </View>
      </Button>
    </View>
  )
})

export const ContactListFooterMargin = memo(() => {
  return <View style={styles.margin} pointerEvents="none" />
})

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    bottom: 32,
    right: 16,
  },
  button: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 76,
    height: 71,
    borderRadius: 38,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 2,
    //   height: 2,
    // },
    // shadowRadius: 2,
    // shadowOpacity: 0.5,
  },
  label: {
    flex: 1,
    color: "#fff",
  },
  margin: {
    height: 120,
  },
})
